// extracted by mini-css-extract-plugin
module.exports = {"Container":"poperties_Container__Al_rJ","Heading":"poperties_Heading__4yo_D","Link":"poperties_Link__QPEEw","Results":"poperties_Results__GTY4w","Result":"poperties_Result___Niw2"};